import React from 'react';
import PropTypes from 'prop-types';
import { wrapperStyle, maskStyle, innerStyle, arrowStyle } from './styles';

export class Carousel extends React.Component {
	static propTypes = {
		children: PropTypes.array,
	};

	state = {
		page: 0,
		leftEnabled: false,
		rightEnabled: false,
	};

	constructor(props) {
		super(props);
		this.innerRef = React.createRef();
		this.outerRef = React.createRef();
	}

	componentDidMount() {
		if (React.Children.count(this.props.children) > 3) {
			this.setState({
				rightEnabled: true,
				leftEnabled: true,
			});
		}
	}

	scrollLeft = () => {
		const outer = this.outerRef.current;
		const inner = this.innerRef.current;
		if (outer == null || inner == null) return;

		const outerWidth = outer.clientWidth;
		const innerWidth = inner.scrollWidth;
		const innerLeft = inner.offsetLeft;
		const page =
			innerLeft < 0 ? Math.round(innerLeft / outerWidth) + 1 : -Math.floor(innerWidth / outerWidth);
		inner.style.left = `calc(${page * 100}% - ${-page * 24}px)`;
	};

	scrollRight = () => {
		const outer = this.outerRef.current;
		const inner = this.innerRef.current;
		if (outer == null || inner == null) return;

		const outerWidth = outer.clientWidth;
		const innerWidth = inner.scrollWidth;
		const innerLeft = inner.offsetLeft;
		const upperLim = Math.floor(innerWidth / outerWidth) * outerWidth;
		if (-innerLeft < upperLim) {
			const page = Math.round(innerLeft / outerWidth) - 1;
			inner.style.left = `calc(${page * 100}% - ${-page * 24}px)`;
		} else {
			inner.style.left = '0';
		}
	};

	render() {
		const { leftEnabled, rightEnabled } = this.state;
		return (
			<div className={wrapperStyle}>
				<div className={maskStyle} ref={this.outerRef}>
					<div className={innerStyle} ref={this.innerRef}>
						{this.props.children}
					</div>
				</div>
				{leftEnabled && <button className={arrowStyle('left')} onClick={this.scrollLeft} />}
				{rightEnabled && <button className={arrowStyle('right')} onClick={this.scrollRight} />}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/carousel/component.js